import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'react-spreadsheet-grid';
import { fetchDetailsRequest, fetchMasterMappingRequest } from '../redux/actions';
import { Typography, Button } from '@mui/material';
import GridTitle from './GridTitle';
import GridTypography from './GridTypography';
import Loader from './Loader';
import EntryDialog from './EntryDialog';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function Details(props) {
    const { engagementCode, branchSubCode } = props;
    const dispatch = useDispatch();

    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([]);
    const [masterMappingData, setMasterMappingData] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const handleClickOpen = (selectedRow) => {
        setSelectedRow(selectedRow);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { loading: masterMappingLoading, data: masterMappingDataSet, error: masterMappingError } = useSelector((state) => state.masterMapping);
    const { loading, data: detailsDataSet, error } = useSelector((state) => state.details);

    useEffect(() => {
        if (engagementCode && branchSubCode) {
            dispatch(fetchMasterMappingRequest());
            dispatch(fetchDetailsRequest(engagementCode, branchSubCode));
        }
    }, [branchSubCode, dispatch, engagementCode]);

    useEffect(() => {
        if (detailsDataSet) {
            setRows(detailsDataSet);
        }
    }, [detailsDataSet]);

    useEffect(() => {
        if (masterMappingDataSet) {
            setMasterMappingData(masterMappingDataSet);
        }
    }, [masterMappingDataSet]);

    const initColumns = () => {
        return [
            {
                title: () => {
                    return (
                        <GridTitle title="Account No.#" tooltip="Account No.#" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.accode} tooltip={row.accode} />
                    );
                },
                id: 'accode',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Account Name" tooltip="Account Name" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.acname} tooltip={row.acname} />
                    );
                },
                id: 'acname',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Target Grouping" tooltip="Target Grouping" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getTargetGrouping(row.grouping)} tooltip={getTargetGrouping(row.grouping)} />
                    );
                },
                id: 'targetGroupingId',
            }, {
                title: () => {
                    return (
                        <GridTitle title="FS Notes - same as in TB" tooltip="FS Notes - same as in TB" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getFSNotes(row.grouping)} tooltip={getFSNotes(row.grouping)} />
                    );
                },
                id: 'fsNotes',
            }, {
                title: () => {
                    return (
                        <GridTitle title="FS Lines - same as in TB" tooltip="FS Lines - same as in TB" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getFSLines(row.grouping)} tooltip={getFSLines(row.grouping)} />
                    );
                },
                id: 'fsLines',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Interim" tooltip="Interim" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.interim} tooltip={row.interim} />
                    );
                },
                id: 'interim',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Preliminary" tooltip="Preliminary" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.preliminary} tooltip={row.preliminary} />
                    );
                },
                id: 'preliminary',
            }, {
                title: () => {
                    return (
                        <GridTitle title="CJE" tooltip="CJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        // <GridTypography title={row.cjetotal} tooltip={row.cjetotal} />
                        <Button
                            variant="text"
                            onClick={() => handleClickOpen(row)}
                            sx={{
                                fontSize: '9px',
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "3",
                                WebkitBoxOrient: "vertical",
                            }}>
                            {row.cjetotal}
                        </Button>
                    );
                },
                id: 'cjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Adjusted" tooltip="Adjusted" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.adjusted} tooltip={row.adjusted} />
                    );
                },
                id: 'adjusted',
            }, {
                title: () => {
                    return (
                        <GridTitle title="GJE" tooltip="GJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.gjetotal} tooltip={row.gjetotal} />
                    );
                },
                id: 'gjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Final" tooltip="Final" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.final} tooltip={row.final} />
                    );
                },
                id: 'final',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Previous Year" tooltip="Previous Year" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.pfy} tooltip={row.pfy} />
                    );
                },
                id: 'pfy',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 2" tooltip="Comparative 2" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp2} tooltip={row.comp2} />
                    );
                },
                id: 'comp2',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 3" tooltip="Comparative 3" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp3} tooltip={row.comp3} />
                    );
                },
                id: 'comp3',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 4" tooltip="Comparative 4" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp4} tooltip={row.comp4} />
                    );
                },
                id: 'comp4',
            }, {
                title: () => {
                    return (
                        <GridTitle
                            title="Document Number / Section Name - Same as in ADAT Index"
                            tooltip="Document Number / Section Name - Same as in ADAT Index" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getSection(row.grouping)} tooltip={getSection(row.grouping)} />
                    );
                },
                id: 'sectionNameTestingSheets',
            }, {
                title: () => {
                    return (
                        <GridTitle
                            title="Document Number / Section Name - Same as in ADAT Index for Preliminary Analysis"
                            tooltip="Document Number / Section Name - Same as in ADAT Index for Preliminary Analysis" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getAPSection(row.grouping)} tooltip={getAPSection(row.grouping)} />
                    );
                },
                id: 'sectionNamePreliminaryTemplates',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Aggregate Name for CAP" tooltip="Aggregate Name for CAP" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={getAggregate(row.grouping)} tooltip={getAggregate(row.grouping)} />
                    );
                },
                id: 'sectionNamePreliminaryTemplates',
            }
        ]
    };

    useEffect(() => {
        if (rows && rows.length > 0 && masterMappingData && masterMappingData.length > 0) {
            setColumns(initColumns());
        }
    }, [rows, masterMappingData])

    const onFieldChange = (rowId, field) => (value) => {
        setRows((prevData) =>
            prevData.map((item) =>
                item.id === rowId ? { ...item, [field]: value } : item
            )
        );
    };

    const getTargetGrouping = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.grouping : '-';
        }
        return '-';
    }

    const getFSNotes = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.fsnote : '-';
        }
        return '-';
    };

    const getFSLines = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.fsline : '-';
        }
        return '-';
    };

    const getSection = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.section : '-';
        }
        return '-';
    };

    const getAPSection = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.apSection : '-';
        }
        return '-';
    };

    const getAggregate = (targetGroupingId) => {
        if (masterMappingData && masterMappingData.length > 0) {
            const targetGrouping = masterMappingData.find((item) => item.grouping === targetGroupingId);
            return targetGrouping ? targetGrouping.aggregate : '-';
        }
        return '-';
    };

    // const getAdjustedAmount = (rowId) => {
    //     const row = rows.find((r) => r.id === rowId);
    //     return row ? parseFloat(row.preliminary) + parseFloat(row.cje) : '-';
    // };

    // const getFinalAmount = (rowId) => {
    //     const row = rows.find((r) => r.id === rowId);
    //     return row ? parseFloat(row.preliminary) + parseFloat(row.cje) + parseFloat(row.gje) : '-';
    // };

    const onColumnResize = (widthValues) => {
        const newColumns = [].concat(columns)
        Object.keys(widthValues).forEach((columnId) => {
            const column = columns.find(({ id }) => id === columnId)
            column.width = widthValues[columnId]
        })
        setColumns(newColumns)
    };

    return (
        <>
            {loading && <Loader />}
            {error && <Typography color="error">Error: {error}</Typography>}
            {columns && columns.length > 0 &&
                <Grid
                    columns={columns}
                    rows={rows}
                    getRowKey={row => row.id}
                    focusOnSingleClick={true}
                    isScrollable
                />
            }
            {open && <EntryDialog open={open} handleClose={handleClose} selectedRow={selectedRow} accountDetails={rows} />}
        </>

    )
}

export default Details;